export enum ConsentDisplayModeEnum {
    LONG = 'long',
    SHORT = 'short',
}

export type ConsentSettingsCheckboxModel = {
    key: string;
    required: boolean;
};

export type ConsentSettingsItemModel = {
    item_id: string;
    show: boolean;
    checkboxes: ConsentSettingsCheckboxModel[];
};

export type ConsentPlaceholdersModel = {
    customer_legal_name: string;
    customer_privacy_email: string;
};

export type ConsentPolicyUrlsModel = {
    retention: string;
    privacy: string;
};

export type ConsentSettingsModel = {
    enabled: boolean;
    template_id?: string;
    display_mode: ConsentDisplayModeEnum;
    items: ConsentSettingsItemModel[];
    placeholders: ConsentPlaceholdersModel;
    policy_urls: ConsentPolicyUrlsModel;
};
